import theme from "assets/theme";
import { React, useContext, useEffect, useMemo, useState } from "react";
import { ActivityIndicator, StyleSheet, Text, View } from "react-native";
import CustomButton from "webComponentsFormElements/inputs/CustomButton.component";
import SearchBar from "webComponentsFormElements/inputs/SearchBar.component";
import ResourceCard from "webComponentsScreens/bcp-info/ResourceCard.component";
import ResourceEditModal from "webComponentsScreens/bcp-info/ResourceEditModal.component";
import { OrganizationContext } from "webContext/Organization.context";

const classes = StyleSheet.create({
  root: {
    gap: 20,
    overflow: "auto",
  },
  searchContainer: {
    maxWidth: 500,
  },
  cardsContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 15,
    overflow: "auto",
  },
  text: {
    margin: 8,
    color: theme.color.backgroundText,
  },
  noneText: {
    fontStyle: "italic",
  },
});

export default function BcpInfoScreen() {
  const { organizationResources, getOrganizationResources } =
    useContext(OrganizationContext);

  const [isLoading, setIsLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [openResource, setOpenResource] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await getOrganizationResources();
      setIsLoading(false);
    };
    fetchData();
  }, [getOrganizationResources]);

  const searchedResources = useMemo(() => {
    return searchValue.length
      ? organizationResources.filter((resource) =>
          resource.title
            .toLowerCase()
            .trim()
            .includes(searchValue.toLowerCase().trim()),
        )
      : organizationResources;
  }, [organizationResources, searchValue]);

  if (isLoading) {
    return <ActivityIndicator size="large" />;
  }

  return (
    <View style={classes.root}>
      <ResourceEditModal
        open={isEditModalOpen}
        onClose={() => {
          setIsEditModalOpen(false);
        }}
        resource={openResource}
      />
      <View style={classes.searchContainer}>
        <SearchBar
          placeholder="Search resources..."
          value={searchValue}
          onChangeText={setSearchValue}
        />
      </View>
      <View style={classes.cardsContainer}>
        {searchedResources.map((resource) => (
          <ResourceCard
            key={resource.resourceId}
            resource={resource}
            onPress={() => {
              setOpenResource(resource);
              setIsEditModalOpen(true);
            }}
          />
        ))}
        {searchedResources.length === 0 && (
          <Text style={[classes.text, classes.noneText]}>
            No resources available.
          </Text>
        )}
      </View>
      <CustomButton
        title="Add resource"
        icon="plus-circle-outline"
        variant="dark"
        onPress={() => {
          setIsEditModalOpen(true);
          setOpenResource(null);
        }}
      />
    </View>
  );
}
